import React from "react";

export function Avatar({ name = "", color = "#002FA7", size = 40, className = "", src = "" }) {
  const initials = name
    .split(" ")
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
  if (src) {
    return (
      <img src={src} alt={name} className={`rounded-full object-cover shrink-0 ${className}`} style={{ width: size, height: size }} />
    );
  }
  return (
    <div
      className={`flex items-center justify-center rounded-full font-cabinet font-bold shrink-0 ${className}`}
      style={{ background: color, width: size, height: size, fontSize: size * 0.4, color: "#fff" }}
    >
      {initials || "?"}
    </div>
  );
}
